import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InstantAccess } from './components/InstantAccess';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
type AppProps = {
  showCountdownBar?: boolean;
  showBonuses?: boolean;
};
export function App({
  showCountdownBar = true,
  showBonuses = true
}: AppProps) {
  return <div className="w-full bg-cream" data-id="element-0" data-mp="23vciyq2516ak">
      <MetaPixel data-id="element-1" data-mp="23u9t8lgjx9w8" />
      {showCountdownBar && <CountdownBar data-id="element-2" data-mp="23t8hsfvmildz" />}
      <main data-id="element-3" data-mp="3ijxo6nd1puib">
        <Hero data-id="element-4" data-mp="3ikh8gaq64uzi" />
        <StatsBar data-id="element-5" data-mp="3ikqytzf4l45q" />
        <Difference data-id="element-6" data-mp="3ij61y35c994p" />
        <Recognize data-id="element-7" data-mp="3ihv22ef0kliv" />
        <WhatsInside data-id="element-8" data-mp="3mljaezbgzl56" />
        <InstantAccess data-id="element-9" data-mp="3ml1234bj9ggw" />
        {showBonuses && <Bonuses data-id="element-10" data-mp="3mjzpgvevclx2" />}
        <Offer data-id="element-11" data-mp="3mj6ibtbzzuee" />
        <Guarantee data-id="element-12" data-mp="3rc9hqi3ghy2i" />
        <Testimonials data-id="element-13" data-mp="3rbzn2h7gv2qh" />
        <Faq data-id="element-14" data-mp="3rdkg22e4udm8" />
      </main>
      <Footer data-id="element-15" data-mp="3recedkz46pg7" />
    </div>;
}